// extracted by mini-css-extract-plugin
export default {"boxpro":"About_boxpro__mfuuv","desc":"About_desc__Hpylr","icon":"About_icon__QXD9T","btn":"About_btn__cVBq1","name":"About_name__Q69qU","deg":"About_deg__v42pL"};